// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"71f1ad3d","84":"1eeeae1c","358":"60b99cde","368":"cd39faec","510":"c6019d84","611":"75f4cc4a","778":"c7021259","900":"db8066c2","920":"5b5c7cfc","936":"3539f61f"}[chunkId] + ".chunk.js";
};